import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import store from './store';
import PrivateRoute from './components/Routing/PrivateRoute';

import Home from './pages/Home/Home';
import Homepage from './pages/Homepage/b2chome';
import AboutUs from './pages/AboutUs/AboutUs';
import CartView from './pages/CartView/CartView';
import Checkout from './pages/CartView/Checkout';
import DetailProduct from './pages/DetailProduct/DetailProduct';
import Login from './pages/Login/Login';
import LoginCopy from './pages/Login/Login copy';
import Product from './pages/Product/Product';
import AliexpressPage from './pages/AliExpress/AliexpressPage';
import OximoProductPage from './pages/Oximo/OximoProductPage';
import OximoProductDetail from './pages/Oximo/OximoProductDetail';
import Dashboard from './pages/Dashboard/Dashboard';
import CompanyRoleDashboard from './pages/Dashboard/CompanyRoleDashboard';
import SellerProductList from './pages/SellerProductList/SellerProductList';
import Signup from './pages/Signup/Signup';
import SignupAdmin from './pages/Signup/SignupAdmin';
import PreviewImages from './pages/PreviewImages/PreviewImages';
import UploadData from './pages/PreviewImages/UploadApiData';
import VCard from './pages/Vcard/vcard';
import VehicleDropdown from './pages/Vcard/VehicleDataModal';
import OximoPricePage from './pages/Oximo/Backend/OximoProductPage';
import AliProductList from './pages/AliExpress/AliProductList';
import AliProductDetail from './pages/AliExpress/AliProductDetail';
import 'react-quill/dist/quill.snow.css';

// ASPL
import AsplHomePage from './pages/Aspl/AsplHomePage';
import AsplDetailPage from './pages/Aspl/AsplDetailPage';
import AsplAdminPage from './pages/Aspl/Backend/AsplAdminPage';

function App() {
  useEffect(() => {
    const disableContextMenu = (e) => e.preventDefault();
    document.addEventListener('contextmenu', disableContextMenu);
    return () => document.removeEventListener('contextmenu', disableContextMenu);
  }, []);

  const tokenString = localStorage.getItem('token');
  const token = tokenString ? JSON.parse(tokenString) : null;
  const tokenReady = token?.role?.id !== undefined;

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/product" element={<Product />} />
          <Route path="/aliexpress_product" element={<AliexpressPage />} />
          <Route path="/oximo-product" element={<OximoProductPage />} />
          <Route path="/updateoximo" element={<OximoPricePage />} />
          <Route path="/product/:symbol" element={<OximoProductDetail />} />
          <Route path="/vcard" element={<VCard />} />
          <Route path="/vehicledata" element={<VehicleDropdown />} />
          {/* <Route path="/detail_product" element={<DetailProduct />} /> */}
          <Route path="/detail_page/:id" element={<DetailProduct />} />
          <Route path="/aliproduct" element={<AliProductList />} />
          <Route path="/aliproduct/:productId" element={<AliProductDetail />} />

          {/* ASPL ROUTE */}
          <Route path="/aspl" element={<AsplHomePage />} />
          <Route path="/aspl/product/:id" element={<AsplDetailPage />} />


          {/* Protected Routes - Admin (role 1) */}
          <Route element={<PrivateRoute allowedRoles={[1]} />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/seller_product_list" element={<SellerProductList />} />
            <Route path="/previewImages" element={<PreviewImages />} />
            <Route path="/upload_data" element={<UploadData />} />
            <Route path="/dashboard/aspl-prices" element={<AsplAdminPage />} />
          </Route>

          {/* Company Dashboard Route - Roles 2 to 6 */}
          <Route element={<PrivateRoute allowedRoles={[2, 3, 4, 5, 6]} />}>
            <Route path="/company-dashboard" element={<CompanyRoleDashboard />} />
          </Route>

          {/* Cart and Checkout - Any logged-in user */}
          <Route element={<PrivateRoute />}>
            <Route path="/cartView" element={<CartView />} />
            <Route path="/checkout" element={<Checkout />} />
          </Route>

          {/* Auth */}
          <Route path="/adminlogin" element={tokenReady ? <Navigate to="/dashboard" /> : <Login />} />
          <Route path="/adminsignup" element={tokenReady ? <Navigate to="/dashboard" /> : <Signup />} />
          <Route path="/login" element={tokenReady ? <Navigate to="/" /> : <LoginCopy />} />
          <Route path="/signup" element={tokenReady ? <Navigate to="/" /> : <Signup />} />
          <Route path="/signup-encrypted-admin" element={tokenReady ? <Navigate to="/" /> : <SignupAdmin />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
